<div *ngIf="files != undefined" class="sourceFileList">
  <source-file class="sourceFile"
               *ngFor="let file of files"
               [file]="file" [pId]="pId" [expectedLanguage]="expectedLanguage" [allowRemoval]="allowRemoval"
               [service]="service"
               (onFileRemove)="removeFile($event)"
               (onDocPdfUpload)="docFileUploaded($event)"
               (onFileMetaUpdate)="fileDataUpdated($event)"></source-file>
</div>
